import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { RmpvPassagemService } from '../rmpv-passagem-service/rmpv-passagem.service';
import { Filtros } from '../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { IColunaGrid } from '../../../../shared/gridview/estrutura/IColunaGrid';
import { EstruturaGridViewBuilder } from '../../../../shared/gridview/EstruturaGridViewBuilder';
import { Parametro } from '../../../../shared/service-base/parametro';
import { TotalizadorResumo } from './totalizador-resumo';

@Component({
  selector: 'app-rmpv-passagem-lista',
  templateUrl: './rmpv-passagem-lista.component.html',
  styleUrls: ['./rmpv-passagem-lista.component.css'],
})

export class RmpvPassagemListaComponent extends ListaBase implements OnInit {

  arrayTranslate = [{categoria: "Cliente", chave:"rmpv.passagem.cliente"},
                   {categoria:"Garantia", chave:"rmpv.passagem.garantia"},
                   {categoria:"Funilaria e Pintura", chave: "rmpv.passagem.funilariaPintura"},
                   {categoria:"Acessório", chave: "rmpv.passagem.acessorio"},
                   {categoria:"Motos usadas", chave: "rmpv.passagem.motosUsada"},
                   {categoria:"Outras Internas", chave: "rmpv.passagem.outraInterna"},
                   {categoria:"Cortesia", chave: "rmpv.passagem.cortesia"},
                   {categoria:"Revisão", chave: "rmpv.passagem.revisao"},
                   {categoria:"Seguro/Franquia", chave: "rmpv.passagem.seguroFranquia"},
                   {categoria:"Outras", chave: "rmpv.passagem.outra"},
                   {categoria:"Retorno", chave: "rmpv.passagem.retorno"},
                   {categoria:"Recall", chave: "rmpv.passagem.recall"},
                  ];
              
  dadosCache = [];   

  visualizarTotalRegistros: boolean;

  dadosHorizontal: any[] = [];
  estruturaHorizontal: IColunaGrid[] = [];
  totalHorizontal: any[] = [];

  dadosResumo: TotalizadorResumo[] = [];

  marca: any;
  total: TotalizadorResumo;
  totalInternas: TotalizadorResumo;

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  public barChartLabels: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [];
  public barChartColors: any[] = [];
  public exibirBotaoDetalhes: boolean;

  detalhe = {
    descricao: 'barraConsulta.verDetalhadoPorMes',
    icone: 'fa fa-calendar',
    acao: function() {
      this.router.navigateByUrl(this.obterUrlComFiltros());
    }.bind(this)
  }

  obterUrlComFiltros(): string {
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }
    return 'rmpv/passagem/mensal' + url;
  }

  constructor(service: RmpvPassagemService, 
              toastr: ToastrService, router: Router,
              private translate: TranslateService) {
    super(service, toastr, router);

    this.exibirBotaoNovo = false;
    this.listagemComPaginacao = false;
    this.quantidadeRegistrosPorPagina = 5;
    this.visualizarTotalRegistros = false;
    this.visualizarTotalInterna = true; // Habilita visualizar a somatória de valores RMPV interna
    this.visualizarTotalGeral = true;  // Habilita visualizar a somatória de valores RMPV geral
    this.exibirBotaoDetalhes = true;
    this.exibirIconBotaoDetalhes = false; // Icone da coluna Detalhe
    this.exibirBotaoDetalhesIcon = true;  // Icone de download
    this.nomeModulo = 'passagem';

    this.getTranslate();
  }

  ngOnInit() {
    this.buscar();
  }

  ngAfterViewChecked() {
    if (this.translate.currentLang === 'gb') {
      this.translate.use('br');
      this.translate.use('gb');
    }    
  }    

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  getDados(response: any): any {
    return this.carregarMarcas(response['marcas']);
  }

  limpar() {
    this.dadosResumo = [];
    this.total = new TotalizadorResumo();
    this.totalInternas = new TotalizadorResumo();
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }

    this.service.listar([], objFiltro)
      .then(itens => {
        this.carregarMarcas(itens['marcas']);
      });
  }

  carregarMarcas(lista: any[]): any {
    this.limpar();

    lista.forEach(element => {
     
        this.totalizarMarca(element.dados);
        this.marca = lista[0].marca;
       
    });

    this.carregarEstruturaResumo();

    return this.dadosResumo;
  }

  private encontrarCategoriaResumo(element: any) {
    const index = this.dadosResumo.findIndex((item) => element.id === item.id);

    let categoria: TotalizadorResumo;

    if (index === -1) {
      categoria = new TotalizadorResumo();
      categoria.id = element.id;
      categoria.categoria = element.nome;
      this.dadosResumo.push(categoria);
    } else {
      categoria = this.dadosResumo[index];
    }

    return categoria;
  }


  totalizarMarca(lista: any[]) {
    lista.forEach(element => {
      const categoria: TotalizadorResumo = this.encontrarCategoriaResumo(element);

      categoria.valorMarca += element.total;

      this.total.valorMarca += categoria.valorMarca;
      this.totalInternas.valorMarca += element.interna ? element.total : 0;
    });
  }

  private carregarEstruturaResumo() {
    this.estrutura = new EstruturaGridViewBuilder()
      .addColunaW('categoria', 'rmpv.passagem.categorias', '50%')
      .addColuna('valorMarca', this.marca)
      .build();

    this.estruturaInterna = new EstruturaGridViewBuilder()
      .addColunaW('', 'rmpv.passagem.internaRetornoUsado', '200px')
      .addColuna('', this.totalInternas.valorMarca.toLocaleString('pt-br'))
      .build();

    this.estruturaTotal = new EstruturaGridViewBuilder()
      .addColunaW('', 'Total', '200px')
      .addColuna('', this.total.valorMarca.toLocaleString('pt-br'))
      .build();
    }

    getTranslate() {
      if (!this.dados) {  
        return;  
      }

        this.translate.onLangChange
                      .subscribe((event: TranslationChangeEvent) => {
                        
          if (this.dados[0]) {
                          
            if (!this.dadosCache.length) {
              this.dadosCache = Array.from(this.dados);
            }

            this.dados = Array.from(this.dadosCache);

            this.translate
                .stream(this.arrayTranslate.map(item => item.chave))
                .subscribe(value => {
    
                  this.dados = this.dados.map(item => Object.assign({}, item));

                  this.dados.forEach(element => {

                    this.arrayTranslate.forEach(item => {
                      if (element.categoria === item.categoria) {
                        element.categoria = value[item.chave];                 
                      }  
                    });
                      
                  });                

                }, error => console.log(error));

        }  
      });   
  }    

   
}
